import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { CreateUpdateDistrictTranslationEntity } from './CreateUpdateDistrictTranslationEntity'

export class CreateUpdateDistrictDataEntity {
  id?: number | null
  externalId?: number
  translations?: Array<CreateUpdateDistrictTranslationEntity>
  boundaryData?: Array<LngLatEntity>
  disabled?: boolean
}
